// src/utils/menuCache.js

const MENU_CACHE_KEY = "dynamic_menu";

export const menuCache = {
  get() {
    const cached = sessionStorage.getItem(MENU_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  },

  set(menu) {
    sessionStorage.setItem(MENU_CACHE_KEY, JSON.stringify(menu));
  },

  clear() {
    sessionStorage.removeItem(MENU_CACHE_KEY);
  },
};
